import { css } from "emotion";

const FlexColumn = ({
  children,
  width = "auto",
  height = "auto",
  className = css({}),
  style = {},
  mobileStyle = {}
}) => {
  const VCenteringWrapper = css({
    maxWidth: width,
    maxHeight: height,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    ...style,
    "@media(max-width: 600px)": {
      ...mobileStyle
    }
  });

  return <div className={css([VCenteringWrapper, className])}>{children}</div>;
};

export default FlexColumn;
